import { option } from 'fp-ts';

import { useCatalogContext } from 'modules/catalog/catalogSelector';
import { CollectionQueryBuilder } from 'modules/catalog/legacyQueryBuilder';
import { useFetchCatalogFields } from 'modules/catalogFieldTypes/hooks';

import { useCatalogSelectionContext } from './contexts/CatalogSelectionContext';
import { QueryBuilderWrapper } from './QueryBuilder.styled';
import { useUpdateBuilderFields } from './hooks/useUpdateBuilderFields';

export const QueryBuilder = () => {
  const { catalog } = useCatalogContext();
  const { isEnabled } = useCatalogSelectionContext();
  const { isLoading } = useFetchCatalogFields(option.toUndefined(catalog)?.name);
  useUpdateBuilderFields();

  if (!isEnabled) return null;

  return (
    <QueryBuilderWrapper>
      <CollectionQueryBuilder
        showDynamicFieldToggle={false}
        showLimitAndOrderBy={false}
        isLoading={isLoading}
        disallowHandlebarsInQuery={true}
      />
    </QueryBuilderWrapper>
  );
};
